import { render } from "./InitialPageContentSection.vue?vue&type=template&id=1a1f0d0a&scoped=true"
import script from "./InitialPageContentSection.vue?vue&type=script&lang=js"
export * from "./InitialPageContentSection.vue?vue&type=script&lang=js"

import "./InitialPageContentSection.vue?vue&type=style&index=0&id=1a1f0d0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a1f0d0a"

export default script